import React, { useState, useEffect, useCallback } from 'react';
import Pagination from '../Pagination';
import axios from '../../api/api';
import { MdOutlineBlock } from 'react-icons/md';
import Loader from '../Loader';

const MpesaTransactions = () => {

  const [transaction, setTransaction] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(20);
  const [count, setCount] = useState(0);
  const [total, setTotal] = useState(0);

  // Fetch user transactions
  const getTransactions = useCallback(async (offset, limit, email) => {
    try {
      let query = `?offset=${offset}&limit=${limit}`
      const response = await axios.get(`/topup/${query}`);
      setTransaction(response.data.items);
      setCount(response.data.count)
      setTotal(response.data.total)
      setLoading(false);
      setError(null);
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (!error.response) {
        setError("Network error! Check your connection.");
      } else if (error.response.status) {
        setError(error.response.data.detail)
      } else if (error.response.status >= 500) {
        setError("Server error! Please try again later.");
      } else {
        setError("An unexpected error occurred!");
      }
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    getTransactions((currentPage - 1) * recordsPerPage, recordsPerPage);
  }, [currentPage, recordsPerPage, getTransactions]);

  return (
    <div className='mx-auto p-4'>
      <div className="bg-white rounded-lg p-4 w-full flex-1 min-w-0">
        <h5 className='text-[#165277] font-bold my-4'>Showing {count} / {total} Mpesa Transactions</h5>
        {loading ? (
          <div className='flex items-center justify-center bg-[#e9f3f9] h-[70vh]'>
            <Loader />
          </div>
        ) : error ? (
          <div className='bg-[#e9f3f9] grid place-items-center h-[70vh]'>
            <div className='grid place-items-center text-red-600 p-4'>
              <h3><MdOutlineBlock /></h3>
              <span>{error}</span>
            </div>
          </div>
        ) : (
          <div className='overflow-x-auto rounded-lg'>
            {transaction.length > 0
              ? (
                <table className='w-full text-left table-auto'>
                  <thead>
                    <tr className='border-b border-slate-500'>
                      <th className='p-2'>No</th>
                      <th className='p-2'>Mpesa Code</th>
                      <th className='p-2'>Phone</th>
                      <th className='p-2'>Amount</th>
                      <th className='p-2'>Units</th>
                      <th className='p-2'>Commission</th>
                      <th className='p-2'>Units Before</th>
                      <th className='p-2'>Units After</th>
                      <th className='p-2'>Created By</th>
                      <th className='p-2'>Organization</th>
                      <th className='p-2'>Service Client</th>
                      <th className='p-2'>Status</th>
                      <th className='p-2'>Created At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transaction.map((transaction) => (
                      <tr key={transaction.id}>
                        <td className='p-2 '>{transaction.id}</td>
                        <td className='p-2'>{transaction.transaction_id}</td>
                        <td className='p-2'>{transaction.phone}</td>
                        <td className='p-2'>{transaction.amount?.toLocaleString()}</td>
                        <td className='p-2'>{transaction.units?.toLocaleString()}</td>
                        <td className='p-2'>{transaction.commission}%</td>
                        <td className='p-2'>{transaction.units_before?.toLocaleString()}</td>
                        <td className='p-2'>{transaction.units_after?.toLocaleString()}</td>
                        <td className='p-2'>{transaction.user}</td>
                        <td className='p-2'>{transaction.client}</td>
                        <td className='p-2'>{transaction.service_client}</td>
                        <td className='p-2'>{transaction.status === 'Completed' ? (
                            <span className='bg-[#D9F8EB] text-[#2A8B4F] px-4 py-1 rounded-md font-bold'>Completed</span>
                          ) : (
                            <span className='bg-[#FDE6D8] text-[#AC5A2B] px-4 py-1 rounded-md font-bold'>Failed</span>
                          )}
                        </td>
                        <td className='p-2'>{new Date(transaction.created_at).toLocaleString("en-CA", { hour12: false })}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className='bg-[#e9f3f9] text-[#134463] grid place-items-center h-[70vh]'>
                  <div className='grid place-items-center p-4'>
                    <h3><MdOutlineBlock /></h3>
                    <h4>No Data</h4>
                  </div>
                </div>
              )}
          </div>
        )}
        <div className='flex flex-wrap items-center justify-between mt-4 gap-4'>
          <div>
            <span className='mr-2'>Records per page:</span>
            <select
              className='px-3 py-1 border bg-[#e9f3f9] border-slate-300 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277] focus:ring-1'
              value={recordsPerPage}
              onChange={(e) => {
                setRecordsPerPage(parseInt(e.target.value, 10));
                setCurrentPage(1);
              }}
            >
              <option value='20'>20</option>
              <option value='50'>50</option>
              <option value='75'>75</option>
              <option value='100'>100</option>
            </select>
          </div>
          <Pagination
            nPages={Math.ceil(total / recordsPerPage)}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default MpesaTransactions;
